import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Layout from './components/Layout';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Contact from './pages/Contact';
import CarLoanCalculator from './pages/CarLoanCalculator';
import CarLoanEMICalculator from './pages/CarLoanEMICalculator';
import CarLoanInterestCalculator from './pages/CarLoanInterestCalculator';
import CarLoanAmortizationCalculator from './pages/CarLoanAmortizationCalculator';
import StampDutyCalculator from './pages/StampDutyCalculator';
import FourWDLoanCalculator from './pages/FourWDLoanCalculator';
import FarmVehicleFinanceCalculator from './pages/FarmVehicleFinanceCalculator';
import UteTruckLoanCalculator from './pages/UteTruckLoanCalculator';
import MilitaryVeteranLoanCalculator from './pages/MilitaryVeteranLoanCalculator';
import MilitaryRelocationLoanCalculator from './pages/MilitaryRelocationLoanCalculator';
import EarlyPayoffCalculator from './pages/EarlyPayoffCalculator';
import LeaseVsBuyCalculator from './pages/LeaseVsBuyCalculator';
import BalloonPaymentCalculator from './pages/BalloonPaymentCalculator';
import NovatedLeaseCalculator from './pages/NovatedLeaseCalculator';
import ChattelMortgageCalculator from './pages/ChattelMortgageCalculator';
import CarRefinanceCalculator from './pages/CarRefinanceCalculator';
import CarLoanPayoutCalculator from './pages/CarLoanPayoutCalculator';
import LuxuryCarTaxCalculator from './pages/LuxuryCarTaxCalculator';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';

// Admin redirect component
const AdminRedirect: React.FC = () => {
  useEffect(() => {
    // Redirect to the Netlify CMS admin page which is served statically
    window.location.href = '/admin/';
  }, []);
  
  return <div className="text-center py-8">Redirecting to admin panel...</div>;
};

const Router: React.FC = () => {
  return (
    <Routes>
      <Route element={<Layout />}>
        {/* Main Pages */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/car-loan-calculator" element={<CarLoanCalculator />} />
        <Route path="/car-loan-emi-calculator" element={<CarLoanEMICalculator />} />
        <Route path="/car-loan-interest-calculator" element={<CarLoanInterestCalculator />} />
        <Route path="/car-loan-amortization-calculator" element={<CarLoanAmortizationCalculator />} />
        <Route path="/stamp-duty-calculator" element={<StampDutyCalculator />} />
        <Route path="/early-payoff-calculator" element={<EarlyPayoffCalculator />} />
        <Route path="/lease-vs-buy-calculator" element={<LeaseVsBuyCalculator />} />
        <Route path="/balloon-payment-calculator" element={<BalloonPaymentCalculator />} />
        <Route path="/novated-lease-calculator" element={<NovatedLeaseCalculator />} />
        <Route path="/chattel-mortgage-calculator" element={<ChattelMortgageCalculator />} />
        <Route path="/luxury-car-tax-calculator" element={<LuxuryCarTaxCalculator />} />
        <Route path="/car-refinance-calculator" element={<CarRefinanceCalculator />} />
        <Route path="/car-loan-payout-calculator" element={<CarLoanPayoutCalculator />} />
        <Route path="/4wd-loan-calculator" element={<FourWDLoanCalculator />} />
        <Route path="/farm-vehicle-finance-calculator" element={<FarmVehicleFinanceCalculator />} />
        <Route path="/ute-truck-loan-calculator" element={<UteTruckLoanCalculator />} />
        <Route path="/military-veteran-loan-calculator" element={<MilitaryVeteranLoanCalculator />} />
        <Route path="/military-relocation-loan-calculator" element={<MilitaryRelocationLoanCalculator />} />
        
        {/* Blog Pages */}
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        
        {/* Admin Redirect */}
        <Route path="/admin" element={<AdminRedirect />} />
      </Route>
    </Routes>
  );
};

export default Router;